<div class="gfp-wrapper">
    <!-- Trigger Button -->
    <div class="gfp-trigger" #triggerButton (click)="toggleDropdown()">
        <div class="gfp-trigger-content">
            <span class="gfp-family-name">
                {{ font.family || 'Select Font' }}
            </span>
            <span class="gfp-meta">
                {{ currentStyleLabel }} &middot; {{ font.size || '16px' }}
            </span>
        </div>
        <mat-icon class="gfp-arrow">
            {{ isOpen ? 'expand_less' : 'expand_more' }}
        </mat-icon>
    </div>

    <!-- Dropdown Panel -->
    <div class="gfp-dropdown" *ngIf="isOpen" #dropdownPanel>
        <!-- Search -->
        <div class="gfp-search">
            <mat-icon class="gfp-search-icon">search</mat-icon>
            <input
                #searchInput
                type="text"
                class="gfp-search-input"
                placeholder="Search fonts..."
                [formControl]="searchControl"
                autocomplete="off"
            />
            <mat-icon
                *ngIf="searchControl.value"
                class="gfp-clear-icon"
                (click)="searchControl.setValue(''); $event.stopPropagation()"
            >
                close
            </mat-icon>
        </div>

        <!-- Presets -->
        <div
            class="gfp-presets"
            *ngIf="presetFontItems.length > 0 && !searchControl.value"
        >
            <div class="gfp-section-label">{{ presetLabel }}</div>
            <div
                class="gfp-font-item"
                *ngFor="let item of presetFontItems; trackBy: trackByFamily"
                [class.selected]="isFontSelected(item)"
                (click)="selectFontFamily(item)"
            >
                <span
                    class="gfp-font-name"
                    [ngStyle]="getFontPreviewStyle(item)"
                >
                    {{ item.family }}
                </span>
                <mat-icon class="gfp-check" *ngIf="isFontSelected(item)">
                    check
                </mat-icon>
            </div>
            <mat-divider></mat-divider>
        </div>

        <!-- Font List -->
        <div class="gfp-font-list" (scroll)="onScroll($event)">
            <div class="gfp-loading" *ngIf="loading">
                <mat-spinner diameter="24"></mat-spinner>
                <span>Loading fonts...</span>
            </div>

            <div
                class="gfp-section-label"
                *ngIf="!loading && displayedFonts.length > 0"
            >
                All Fonts ({{ filteredFonts.length }})
            </div>

            <div
                class="gfp-font-item"
                *ngFor="let item of displayedFonts; trackBy: trackByFamily"
                [class.selected]="isFontSelected(item)"
                (click)="selectFontFamily(item)"
            >
                <span
                    class="gfp-font-name"
                    [ngStyle]="getFontPreviewStyle(item)"
                >
                    {{ item.family }}
                </span>
                <span class="gfp-font-category">{{ item.category }}</span>
                <mat-icon class="gfp-check" *ngIf="isFontSelected(item)">
                    check
                </mat-icon>
            </div>

            <div
                class="gfp-no-results"
                *ngIf="!loading && displayedFonts.length === 0"
            >
                No fonts found
            </div>
        </div>

        <!-- Style & Size Controls -->
        <div class="gfp-controls" *ngIf="selectedFont">
            <mat-divider></mat-divider>
            <div class="gfp-controls-row">
                <!-- Style Select -->
                <div class="gfp-control-group">
                    <label class="gfp-control-label">Style</label>
                    <select
                        class="gfp-style-select"
                        [ngModel]="font.style"
                        (ngModelChange)="onStyleChange($event)"
                    >
                        <option
                            *ngFor="let v of selectedFont.variants"
                            [value]="v"
                        >
                            {{ getStyleLabel(v) }}
                        </option>
                    </select>
                </div>

                <!-- Size Input -->
                <div class="gfp-control-group">
                    <label class="gfp-control-label">Size (px)</label>
                    <input
                        type="number"
                        class="gfp-size-input"
                        min="1"
                        max="200"
                        [formControl]="sizeControl"
                    />
                </div>
            </div>
        </div>
    </div>
</div>
